import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigCmsLinkComponent } from './uig-cms.component';
import { RouterModule } from '@angular/router';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';



@NgModule({
  declarations: [UigCmsLinkComponent],
  exports: [UigCmsLinkComponent],
  imports: [
    CommonModule,
    RouterModule,
    IconModule,
    MediaModule,
    UrlModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        UigCMSLinkComponent: {
          component: UigCmsLinkComponent
        }
      }
    } as CmsConfig),
  ]
})
export class UigCmsLinkModule { }